import React from 'react'
import './JakDodacStyle.css'
import PushIcon from '../../icons/PushIcon'

const JakDodacTo = () => {
  const userAgent = navigator.userAgent
  const isIOS = /iPad|iPhone|iPod/.test(userAgent)
  const isAndroid = /Android/.test(userAgent)

  const instructions = isIOS
    ? [
        'Otwórz Safari, przeglądarkę dostarczaną z urządzeniami iOS.',
        'Przejdź do strony internetowej, którą chcesz dodać do pulpitu.',
        'Na dole ekranu (na iPhonie) lub na górze ekranu (na iPadzie) stuknij ikonę "Udostępnij" (kwadrat ze strzałką).',
        'Przewiń w dół i znajdź opcję "Dodaj do pulpitu" i dotknij jej.',
        'Nadaj wartości na pulpicie nazwę skrótu i kliknij "Dodaj".'
      ]
    : isAndroid
    ? [
        'Otwórz przeglądarkę na urządzeniu z Androidem.',
        'Przejdź do strony internetowej, którą chcesz dodać do pulpitu.',
        'Kliknij ikonę "Dash" (zwykle w prawym górnym rogu przeglądarki), aby otworzyć меню.',
        'Wybierz "Dodaj do pulpitu" lub podobną opcję.',
        'Nadaj wartości na pulpicie nazwę skrótu i kliknij "Dodaj" lub "Gotowe".'
      ]
    : []

  if (!isIOS && !isAndroid) {
    return <p>Nie można określić systemu operacyjnego.</p>
  }

  return (
    <div className='jak-dodac-wrapper'>
      <div
        className='instructions-container'
        style={{ backgroundColor: 'rgba(0, 163, 255, 0.12)', padding: '20px', boxSizing: 'border-box', width: '100%' }}
      >
        <div className='icon-container' style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
          <PushIcon />
        </div>
        <div className='instructions-content'>
          <h2 className='instruction-title' style={{ textAlign: 'center', marginBottom: '20px' }}>
            Jak dodać aplikację na pulpit?
          </h2>
          <ol
            className='instructions-list'
            style={{ listStyle: 'decimal inside', padding: '0', margin: '0', textAlign: 'left' }}
          >
            {instructions.map((step, index) => (
              <li key={index} className='guide' style={{ marginBottom: '10px', fontSize: '16px' }}>
                {step}
              </li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  )
}

export default JakDodacTo
